import React from "react";
import { Grid, styled } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";

interface MxChangeLogArrowProps {
  /** Valor anterior */
  fromText: string | number | null;
  /** Valor nuevo */
  toText: string | number | null;
  /** Color del ícono flecha (opcional) */
  color?: string;
  /** Encabezado opcional encima de la fila */
  title?: string;
}

export const MxChangeLogPlainArrow: React.FC<MxChangeLogArrowProps> = ({
  fromText,
  toText,
  title,
  color = "primary.main"
}) => {
  return (
    <Grid container my={0.5} rowGap={1} px={1}>
      {title && (
        <Grid container item xs={12}>
          <MxTypography variant="caption" color={color} fontWeight={600}>
            {title}
          </MxTypography>
        </Grid>
      )}
      <Content>
        {/* Valor anterior */}
        <MxTypography
          variant="caption"
          color={"grey.700"}
          fontWeight={300}
          maxWidth={400}
        >
          {fromText ?? "Sin información"}
        </MxTypography>

        {/* Flecha */}
        <MxIcons color={color} size={20}>
          <IconArrowNarrowRight />
        </MxIcons>

        {/* Valor nuevo */}
        <MxTypography variant="caption" color={"grey.700"} fontWeight={300}>
          {toText ?? "Sin información"}
        </MxTypography>
      </Content>
    </Grid>
  );
};

const Content = styled("div")(({ theme }) => ({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "auto auto 1fr",
  alignItems: "center",
  gap: theme.spacing(1.25)
}));
